import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import LanguageToggle from './LanguageToggle';
import { useLanguage } from '../context/LanguageContext';
import styles from './Navbar.module.css';

/*
 * The compass/chat-bubble logo icon used in the header brand link. Was
 * copy-pasted (identical path data) into every page that shows it.
 */
export const BrandIcon = ({ size = 24, style = {} }) => (
  <img src="/replyshoot_logo.png" alt="ReplyShoot" width="150" style={style} />
);

/*
 * Shared page-header <nav>. Every page still supplies its own look via
 * className/innerClassName/brandClassName (each page keeps its own CSS
 * module, so visual design is unchanged) - this component only owns the
 * structural skeleton that was being hand-copied into every page:
 * nav > (optional inner wrapper) > brand link > rest of the nav content.
 */
const Navbar = ({
  className,
  innerClassName,
  style,
  ariaLabel,
  brandTo = '/',
  brandClassName,
  brand,
  children,
  commonNavigation = false,
}) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const { t } = useLanguage();
  const brandLink = (
    <Link to={brandTo} className={`${styles.brandLink} ${brandClassName || ''}`} onClick={() => setMenuOpen(false)}>
      {brand}
    </Link>
  );
  const isLoggedIn = typeof window !== 'undefined' && Boolean(localStorage.getItem('token1'));
  const sharedLinks = (
    <>
      <a href="/#how-it-works" style={{ color: 'inherit', textDecoration: 'none', fontSize: '0.9rem', fontWeight: 500 }}>{t('howItWorks', 'How it Works')}</a>
      <a href="/#pricing" style={{ color: 'inherit', textDecoration: 'none', fontSize: '0.9rem', fontWeight: 500 }}>{t('pricing', 'Pricing')}</a>
      <Link to="/tools" style={{ color: 'inherit', textDecoration: 'none', fontSize: '0.9rem', fontWeight: 500 }}>{t('tools', 'Tools')}</Link>
      {isLoggedIn && <Link to="/dashboard" style={{ color: 'inherit', textDecoration: 'none', fontSize: '0.9rem', fontWeight: 500 }}>{t('dashboard', 'Dashboard')}</Link>}
      <Link to="/audit" style={{ color: '#fff', background: '#9219a6', borderRadius: '8px', padding: '9px 15px', textDecoration: 'none', fontSize: '0.85rem', fontWeight: 700 }}>{t('freeAudit', 'Free Audit')}</Link>
      <LanguageToggle />
      {!isLoggedIn && <Link to="/?login=true" style={{ color: 'inherit', textDecoration: 'none', fontSize: '0.9rem', fontWeight: 500 }}>{t('login', 'Login')}</Link>}
      {!isLoggedIn && <Link to="/?signup=true" style={{ color: '#fff', background: '#151222', borderRadius: '8px', padding: '9px 15px', textDecoration: 'none', fontSize: '0.85rem', fontWeight: 700 }}>{t('signUp', 'Sign Up')}</Link>}
    </>
  );

  const content = commonNavigation ? sharedLinks : children;

  return (
    <nav className={`${styles.navRoot} ${className || ''}`} style={style} aria-label={ariaLabel}>
      {innerClassName ? (
        <div className={`${styles.navInner} ${innerClassName}`}>
          {brandLink}
          <button
            type="button"
            className={styles.menuToggle}
            aria-expanded={menuOpen}
            aria-controls="site-navigation-menu"
            aria-label={menuOpen ? 'Close navigation menu' : 'Open navigation menu'}
            onClick={() => setMenuOpen((open) => !open)}
          >
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" aria-hidden="true">
              {menuOpen ? <><path d="M6 6l12 12" /><path d="M18 6L6 18" /></> : <><path d="M4 6h16" /><path d="M4 12h16" /><path d="M4 18h16" /></>}
            </svg>
          </button>
          <div id="site-navigation-menu" className={`${styles.menu} ${menuOpen ? styles.menuOpen : ''}`} onClick={() => setMenuOpen(false)}>
            {content}
          </div>
        </div>
      ) : (
        <>
          {brandLink}
          <button
            type="button"
            className={styles.menuToggle}
            aria-expanded={menuOpen}
            aria-controls="site-navigation-menu"
            aria-label={menuOpen ? 'Close navigation menu' : 'Open navigation menu'}
            onClick={() => setMenuOpen((open) => !open)}
          >
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" aria-hidden="true">
              {menuOpen ? <><path d="M6 6l12 12" /><path d="M18 6L6 18" /></> : <><path d="M4 6h16" /><path d="M4 12h16" /><path d="M4 18h16" /></>}
            </svg>
          </button>
          <div id="site-navigation-menu" className={`${styles.menu} ${menuOpen ? styles.menuOpen : ''}`} onClick={() => setMenuOpen(false)}>
            {content}
          </div>
        </>
      )}
    </nav>
  );
};

export default Navbar;
